import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { concatMap, map, mergeMap, toArray } from 'rxjs/operators'
import { EntityFilterTile } from '../models/entity-configuration'
import { EntityCount } from '../../../models/entity-count'
import { EntityConfigService } from './entity-config.service'
import { EntityService } from './entity.service'

@Injectable({
  providedIn: 'root'
})
export class EntityTileService {
  constructor(
    private entityConfigService: EntityConfigService,
    private entityService: EntityService
  ) {}

  /** gets the Filter Tiles for the given entity type */
  getEntityFilterTilesWithCount$ = (entityType: string): Observable<EntityFilterTile[]> => {
    return this.entityConfigService.getEntityFilterTiles$(entityType).pipe(
      // first mergeMap makes it possible to loop through all array-items
      mergeMap((tilesArray) => tilesArray),
      // concatMap preserves the order
      concatMap((tile) => {
        return this.entityService
          .countEntities$(entityType, tile.filterExpression)
          .pipe(
            map(
              (valueCount) =>
                new EntityFilterTile(
                  tile.id,
                  tile.header,
                  tile.description,
                  tile.filterExpression,
                  tile.softFilterExpression,
                  valueCount.count
                )
            )
          )
      }),
      toArray()
    )
  }

  /** gets the Filter Tiles for the given entity type */
  getEntityFilterTiles$ = (entityType: string): Observable<EntityFilterTile[]> => {
    return this.entityConfigService.getEntityFilterTiles$(entityType).pipe(
      // first mergeMap makes it possible to loop through all array-items
      mergeMap((tilesArray) => tilesArray),
      // we need to add count as field and set it to 0, since it does not exist in the dto config
      map((tile) => {
        return new EntityFilterTile(
          tile.id,
          tile.header,
          tile.description,
          tile.filterExpression,
          tile.softFilterExpression,
          0
        )
      }),
      toArray()
    )
  }

  getCountOfEntityFilter$ = (entityType: string, filterExpression: string): Observable<EntityCount> => {
    return this.entityService.countEntities$(entityType, filterExpression).pipe()
  }
}
